import 'angular-material';

import config from './config';
import run from './run';

export default angular
  .module('app.theme-palettes', ['ngMaterial'])
  .config(['$mdThemingProvider', '$provide', config])
  .run(['$mdTheming', '$ngRedux', 'ThemeProvider', run]);
